export const MARKET_EVENT_END_AT = '2025-12-31T23:59:59+09:00';
